<template>
  <section class="height-100-p">
    <el-table
      id="shuttle-inbound-data-list"
      :data="shuttleInbound.list"
      v-loading="shuttleInbound.loadingSearch"
      size="mini"
      tooltip-effect="dark"
      class="dark-blue-table"
      :empty-text="$t('common.notAbleToFindRecords')"
      @sort-change="handleSortChange"
      :default-sort = "{prop: 'number', order: 'descending'}"
      sortable
      stripe
    >
      <el-table-column
        prop="number"
        :label="$t('outbound.shuttleInbound.number')"
        :min-width="5"
        align="center"
        sortable="custom"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.number" placement="top">
            <span> {{ scope.row.number }} </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="dayOfService"
        :label="$t('outbound.shuttleInbound.dayOfService')"
        :min-width="5"
        align="center"
        sortable="custom"
      >
        <template slot-scope="scope">
          <span> {{ scope.row.dayOfService | moment(dateDisplayFormat) }} </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="trailer"
        :label="$t('outbound.shuttleInbound.trailer')"
        :min-width="5"
        align="center"
        sortable="custom"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.trailer" placement="top">
            <span> {{ scope.row.trailer }} </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="loadNumber"
        :label="$t('outbound.shuttleInbound.shuttleInLoad')"
        :min-width="4"
        align="center"
        sortable="custom"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.loadNumber" placement="top">
            <span> {{ scope.row.loadNumber }} </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="receivingWarehouseCode"
        :label="$t('outbound.shuttleInbound.receivingWarehouse')"
        :min-width="4"
        align="center"
        sortable="custom"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :enterable="false" :content="scope.row.receivingWarehouseName" placement="top-start">
            <span>{{ scope.row.receivingWarehouseCode }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="numberOfUnits"
        :label="$t('outbound.shuttleInbound.numberOfUnits')"
        :min-width="4"
        align="center"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        prop="totalCubes"
        :label="$t('outbound.shuttleInbound.totalCubes')"
        :min-width="4"
        align="center"
        sortable="custom"
      >
        <template slot-scope="scope">
          <span> {{ scope.row.totalCubes.toFixed(2) }} </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        :label="$t('outbound.shuttleInbound.status')"
        :min-width="4"
        align="center"
        sortable="custom"
      >
        <template slot-scope="scope">
          <span> {{ shuttleLoadsLabel(scope.row.status) }} </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="releaseTime"
        :label="$t('outbound.shuttleInbound.releasedTime')"
        :min-width="4"
        align="center"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        prop="arrivalTime"
        :label="$t('outbound.shuttleInbound.arrivalTime')"
        :min-width="4"
        align="center"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        :label="$t('common.options')"
        :min-width="4"
        align="center"
      >
        <template slot-scope="scope">
          <set-as-arrived-button v-if="!scope.row.edit" :shuttleLoadId="scope.row.id" :shuttleLoadStatus="scope.row.status" />
          <print-shuttle-sheet-button v-if="!scope.row.edit" :shuttleLoadId="scope.row.id" :shuttleLoadStatus="scope.row.status" />
        </template>
      </el-table-column>
  </el-table>
    <div class="pagination-footer" v-show="shuttleInbound.total > 0">
      <span class="el-pagination__total">
        <span class="el-pagination__title">{{ $t('outbound.shuttleInbound.totalLabel') }}</span>
           {{ shuttleInbound.total }}
      </span>
      <el-pagination
        @size-change="handleSearchChangeLimit"
        :page-sizes="sizes"
        :page-size="shuttleInbound.actualFilters.rows"
        :current-page.sync="shuttleInbound.actualFilters.page"
        @current-change="handleSearchChangePage"
        :total="shuttleInbound.total"
        layout="sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import unitDataTransformLabels from '@/plugins/unitDataTransformLabels';
import constants from '@/utils/constants';
import { SHUTTLE_INBOUND_SEARCH } from '@/store/actions';
import PrintShuttleSheetButton from '@/views/outbound/components/PrintShuttleSheetButton';
import SetAsArrivedButton from '../components/SetAsArrivedButton';

export default {
  name: 'ShuttleInboundSummarySection',
  mixins: [unitDataTransformLabels],
  components: {
    PrintShuttleSheetButton,
    SetAsArrivedButton
  },
  computed: {
    ...mapGetters(['shuttleInbound']),
    sizes() {
      return constants.TABLES.DEFAULT_LIMIT_SIZES;
    },
    dateDisplayFormat() {
      return constants.DATES.DEFAULT_DISPLAY_FORMAT;
    },
  },
  methods: {
    handleSearchChangeLimit(rows) {
      this.$store.dispatch(SHUTTLE_INBOUND_SEARCH, { rows, page: constants.TABLES.DEFAULT_PAGE });
    },
    handleSearchChangePage(page) {
      this.$store.dispatch(SHUTTLE_INBOUND_SEARCH, { page });
    },
    handleSortChange({ prop, order }) {
      this.$store.dispatch(SHUTTLE_INBOUND_SEARCH, { orderField: prop, orderDirection: constants.TABLES.ORDER_DIRECTION[order] });
    },
  }
};
</script>
